import { getRolePermissionFromUser } from "@/api/role";

export default {
  namespaced: true,
  state: {
    regionGuid: "",
    dispName: "",
    userGuid: "",
    userName: "",
    loginNodeGuids: [],
    isSuperNode: false,
    roleGuid: "",
    permissions: []
  },

  getters: {
    regionGuid(state) {
      return state.regionGuid || sessionStorage.getItem("regionGuid") || "";
    },
    userDispName(state) {
      return state.dispName || sessionStorage.getItem("userDispName") || "";
    },
    userGuid(state) {
      return state.userGuid || sessionStorage.getItem("userGuid") || "";
    },
    loginNodeGuids(state) {
      if (!state.loginNodeGuids || !state.loginNodeGuids.length) {
        var storedNodeGuids = sessionStorage.getItem("nodeGuids");
        return storedNodeGuids ? JSON.parse(storedNodeGuids) : [];
      }
      return state.loginNodeGuids;
    },
    userName(state) {
      return state.userName || sessionStorage.getItem("userName") || "";
    },
    isSuperNode(state) {
      return state.isSuperNode || false;
    },
    roleGuid(state) {
      return state.roleGuid || "";
    },
    permissions(state) {
      return state.permissions || [];
    }
  },

  actions: {
    setLoginInfo(
      { commit },
      { regionGuid, userGuid, userName, loginNodeGuids }
    ) {
      commit("SET_REGION_GUID", regionGuid);
      commit("SET_USER_GUID", userGuid);
      commit("SET_USER_NAME", userName);
      commit("SET_LOGIN_NODE_GUIDS", loginNodeGuids);
    },
    clearLoginInfo({ commit }) {
      commit("SET_REGION_GUID", null);
      commit("SET_DISP_NAME", null);
      commit("SET_USER_GUID", null);
      commit("SET_USER_NAME", null);
      commit("SET_LOGIN_NODE_GUIDS", []);
      commit("SET_ROLE_GUID", null);
      commit("SET_PERMISSIONS", []);
    },
    setUserDispName({ commit }, userDispName) {
      commit("SET_DISP_NAME", userDispName);
    },
    async reloadUserRoles({ commit, getters }) {
      try {
        let userRole = await getRolePermissionFromUser(getters.userGuid);
        let permissionNames =
          userRole.permissions && userRole.permissions.length
            ? userRole.permissions.map(p => p.name)
            : [];
        commit("SET_IS_SUPER_NODE", userRole.isSuper);
        commit("SET_ROLE_GUID", userRole.guid);
        commit("SET_PERMISSIONS", permissionNames);
        return permissionNames;
      } catch {
        throw "获取用户权限失败，请联系管理员设置账号权限";
      }
    }
  },

  mutations: {
    SET_REGION_GUID(state, regionGuid) {
      state.guid = regionGuid;
      sessionStorage.setItem("regionGuid", regionGuid);
    },
    SET_DISP_NAME(state, dispName) {
      state.dispName = dispName;
      sessionStorage.setItem("userDispName", dispName);
    },
    SET_USER_GUID(state, userGuid) {
      state.userGuid = userGuid;
      sessionStorage.setItem("userGuid", userGuid);
    },
    SET_USER_NAME(state, userName) {
      state.userName = userName;
      sessionStorage.setItem("userName", userName);
    },
    SET_LOGIN_NODE_GUIDS(state, loginNodeGuids) {
      state.loginNodeGuids = [...loginNodeGuids];
      sessionStorage.setItem("nodeGuids", JSON.stringify(loginNodeGuids));
    },
    SET_IS_SUPER_NODE(state, isSuperNode) {
      state.isSuperNode = isSuperNode;
    },
    SET_ROLE_GUID(state, roleGuid) {
      state.roleGuid = roleGuid;
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    }
  }
};
